import MetricBase from "models/metrics/MetricBase";
import PercentUnit from "models/metrics/unit/PercentUnit";
import i18n from "i18next";
import ConversionGroup from "../../../../groups/ConversionGroup";

class MetricConversionWego extends MetricBase {
    constructor() {
        super({
            field: "metric_conversion_rate",
            defaultVisibility: true,
            unit: new PercentUnit(),
            chartName: i18n.t("metrics.wego.conversion.chartName"),
            serieLabel: i18n.t("metrics.wego.conversion.serieLabel"),
            tooltip: i18n.t("metrics.wego.conversion.tooltip"),
            group: new ConversionGroup(),
        });
    }
}

export default MetricConversionWego;
